import { render, staticRenderFns } from "./Registrar_cotizacion.vue?vue&type=template&id=770e54f4&lang=pug&"
import script from "./Registrar_cotizacion.vue?vue&type=script&lang=js&"
export * from "./Registrar_cotizacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports